<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CWAHlL/tc-custom/9781613123782.jpg?1705234656574" alt="This image is the cover for the book Shadow on the Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadow on the Mountain
      </h1>
      <p class="bookDescription body article font2">
        <b>“Newbery Honor winner Preus . . . delivers a riveting story about teenage freedom fighters in WWII Norway” (<i>Publishers Weekly</i>).</b><br/><br/>After Nazi Germany invades and occupies Norway, fourteen-year-old Espen and his friends are swept up in the Norwegian resistance movement. Espen gets his start by delivering illegal newspapers, then graduates to the role of courier and finally becomes a spy, dodging the Gestapo along the way. During five years under the Nazi regime, Espen, his sister, and their parents live in fear of nighttime raids and arrests, and they begin to question the loyalties of the people around them. Espen gains—and loses—friends, falls in love, and makes one small mistake that threatens to catch up with him as he sets out to escape on skis over the mountains to Sweden . . . <br/><br/>Award-winning author Margi Preus crafts a thrilling adventure based on the real-life experiences of Erling Storrusten, a Norwegian spy during World War II.<br/><br/><b>Praise for <i>Shadow on the Mountain</i></b><br/><br/><b>“Engrossing. . . . This is at once a spy thriller, a coming-of-age story, and a chronicle of escalating bravery. Multidimensional characters fill this gripping tale that keeps readers riveted to the end.” —<i>School Library Journal</i>, starred review</b><br/><br/><b>“A morally satisfying page turner.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margi Preus
      </h2>
      
      <p class="authorDescription body article">Margi Preus is an acclaimed children’s book author and playwright whose first novel, Heart of a Samurai, earned a 2011 Newbery Honor award. She lives in Duluth, Minnesota. Visit her online at www.margipreus.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0622d630